<template>
    <div class="project">

        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect">
            <el-menu-item index="1" @click="component">组方</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: '1',
        handleSelect(key, keyPath) {
        }
      }
    },
    methods: {
      component() {
        this.$router.push({
          path: '/home/project/package'
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// project.vue?7a53e764